import React from "react";
import { Box, TextField, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const LeftText = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl')); 

  return (
    <Box
      width={{ xs: "100%", lg: "60%" }}
      mb={{ xs: "10%", lg: "0" }}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          lineHeight: {
            xs: "5vw",
            sm: "5vw",
            md: "5vw",
            lg: "3vw",
          },
          fontWeight: {
            xs: "500",
            sm: "500",
            md: "500",
            lg: "900",
          },
          color: "#00B49D",
          textTransform: "uppercase",
        }}
        // align="center"
      >
        SEE HOW MUCH YOU COULD SAVE WITH BKV ENERGY - SWITCH AND SAVE TODAY
      </Typography>
      <Typography
        sx={{
          fontSize: "32px",
          lineHeight: "42px",
          "@media (min-width:577px)": {
            fontSize: "52px",
            lineHeight: "52px",
          },
          "@media (min-width:769px)": {
            fontSize: "50px",
            lineHeight: "52px",
          },
          color: theme.palette.primary.main,
          whiteSpace: "wrap",
        }}
        // align="center"
        variant="body2"
        component="h1"
        // padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
      >
        Discover Electricity Savings: Upload Your Bill to Instantly Compare Plans!
      </Typography>
      <ul style={{ marginLeft: "1rem" }}>
        <li>
          <Typography
            sx={{
              fontSize: "16px",
            }}
            variant="body1"
          ><b>
            INSTANT UPLOAD:&nbsp;
          </b>
            Drag and drop your bill!
          </Typography>
        </li>
        <li>
          <Typography
            sx={{
              fontSize: "16px",
            }}
            variant="body1"
          >
            <b>QUICK VERIFICATION:&nbsp;</b>
            Confirm your plan details
          </Typography>
        </li>
        <li>
          <Typography
            sx={{
              fontSize: "16px",
            }}
            variant="body1"
          >
            <b>SHOP ENERGY SAVINGS:&nbsp;</b>
            Find the perfect electricity plan with BKVE
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default LeftText;
